module.exports = __webpack_public_path__ + "052e1b67431ec7e0e76ebd6c714b85ea.png";